import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueQuill from 'vue-quill'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

Vue.use(Vuetify)
Vue.use(VueQuill)

const iconfont = 'mdiSvg'

const vuetify = new Vuetify({
  icons: {
    iconfont
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#6EC8C5',
        secondary: '#5b3e97',
        accent: '#8c9eff',
        error: '#c21e51',
        grey: {
          base: '#9E9E9E',
          lighten3: '#f1f3f4'
        }
      }
    }
  }
})

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: iconfont
})

export default vuetify
